import React, {useEffect, useState} from 'react'
import Table from "../component/Table";
import ModalAddLocation from "./ModalAddLocation";
import API from "../../apiService";
import {showLoading, toast} from "../component/Alert";

const Location = () => {

    const [locations, setLocations] = useState([])
    const [editedLocation, setEditedLocation] = useState(null)
    const [refClinics, setRefClinics] = useState([])
    const [showModal, setShowModal] = useState(false)
    const [clearForm, setClearForm] = useState(0)

    const getLocations = async () => {
        const res = await API.get("management/location/read")
        if (res.code === 200) {
            setLocations(res.data)
        }
    }

    const getRefClinics = async () => {
        const res = await API.get("registration/clinics/read")
        if (res.code === 200) {
            setRefClinics(res.data)
        }
    }

    useEffect(() => {
        getLocations()
        getRefClinics()
    }, [])

    const add = async (data) => {
        showLoading("Menyimpan Data")
        const res = await API.post("management/location/create", data)
        setShowModal(false)
        if (res.code === 200) {
            setClearForm(clearForm + 1)
            setLocations(res.data)
            toast({ status: "success", text: "Berhasil menambahkan data" })
        }
        else {
            toast({ status: "error", text: "Gagal menambahkan data" })
        }
    }

    const edit = async (data) => {
        showLoading("Menyimpan Data")
        const res = await API.put("management/location/update", data)
        setShowModal(false)
        if (res.code === 200) {
            setEditedLocation(null)
            setClearForm(clearForm + 1)
            setLocations(res.data)
            toast({ status: "success", text: "Berhasil mengedit data" })
        }
        else {
            toast({ status: "error", text: "Gagal mengedit data" })
        }
    }

    const destroy = async id => {
        if (confirm('Hapus data ini?')) {
            showLoading("Menghapus Data")
            const res = await API.delete(`management/location/delete/${id}`)
            setShowModal(false)
            if (res.code === 200) {
                setLocations(res.data)
                toast({ status: "success", text: "Berhasil menghapus data" })
            }
            else {
                toast({ status: "error", text: "Gagal menghapus data" })
            }
        }
    }

    return (
        <div className="container-fluid my-3">
            <div className="row">
                <div className="col">
                    <div className="card">
                        <div className="card-header d-flex">
                            <h2 className={'mb-0'}>Location</h2>
                            <div style={{flex: 1}}/>
                            <button className={'btn btn-success'} onClick={() => setShowModal(true)}>Add</button>
                        </div>
                        <div className="card-body">
                            <Table
                                headers={[
                                    "No",
                                    "Name",
                                    "Type",
                                    "Latitude",
                                    "Longitude",
                                    "Location ID",
                                    "Aksi",
                                ]}
                                data={locations}
                                columnMapper={(data, key) => [
                                    data.name,
                                    data.type === 'bu' ? 'Bangunan' : 'Ruangan',
                                    data.lat,
                                    data.lng,
                                    data.location_id,
                                    <div>
                                        <button
                                            className={'btn btn-warning'}
                                            onClick={() => {
                                                setEditedLocation(data)
                                                setShowModal(true)
                                            }}
                                        >
                                            Edit
                                        </button>
                                        <button
                                            className={'btn btn-danger'}
                                            onClick={() => destroy(data.id)}
                                        >
                                            Delete
                                        </button>
                                    </div>
                                ]}
                                pagination={true}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <ModalAddLocation
                show={showModal}
                onHide={() => setShowModal(false)}
                add={add}
                edit={edit}
                refClinics={refClinics}
                refLocation={locations}
                clearForm={clearForm}
                editedLocation={editedLocation}
            />
        </div>
    )
}

export default Location